<div class="top-performance-card">
  <div class="section__header">
    <h2 class="section__title">{{ 'app.components.topPerformance.title' | translate }}</h2>
  </div>
  <div class="performance-list">
    @if (isLoading()) {
      <div class="performance-list__empty">
        <p>{{ 'app.components.topPerformance.loading' | translate }}</p>
      </div>
    } @else if (students().length > 0) {
      @for (s of students(); track $index) {
        <app-student-compact-view [item]="s"></app-student-compact-view>
      }

      @if (totalPages() > 1) {
        <div class="top-performance__pagination">
          <button
            type="button"
            class="top-performance__page-btn"
            (click)="goToPage(currentPage() - 1)"
            [disabled]="currentPage() <= 1"
          >
            {{ 'app.components.topPerformance.pagination.prev' | translate }}
          </button>
          <span class="top-performance__page-info">
            {{ 'app.components.topPerformance.pagination.page' | translate : { current: currentPage(), total: totalPages() } }}
          </span>
          <button
            type="button"
            class="top-performance__page-btn"
            (click)="goToPage(currentPage() + 1)"
            [disabled]="currentPage() >= totalPages()"
          >
            {{ 'app.components.topPerformance.pagination.next' | translate }}
          </button>
        </div>
      }
    } @else {
      <div class="performance-list__empty">
        <p>{{ 'app.components.topPerformance.empty' | translate }}</p>
      </div>
    }
  </div>
</div>
